import React, { useEffect, useState, useRef, useCallback } from 'react'
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import { Box, Typography, Grid, Pagination, Container, Card, Button, InputAdornment, } from '@mui/material';
import { Search as SearchIcon, Clear as ClearIcon } from '@mui/icons-material';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import { BsJustify } from 'react-icons/bs';
import AddIcon from '@mui/icons-material/Add';
import AddPreferredLocation from './AddPreferredLocation';
import EditLocation from './EditLocation';
import { useNavigate } from 'react-router-dom';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import LeadService from '../../core/services/leadsService';
import toast from 'react-hot-toast';
import { Modal } from '@mui/material';
import ImportLocation from './ImportLocation';
import LinearProgress from '@mui/material/LinearProgress';
import { debounce, throttle } from 'lodash';
import '../ServicesMenu/servicesMenu.css';
import { makeStyles } from '@mui/styles';
import { useTheme } from '@mui/material/styles';
import { GlobalStyles } from '@mui/system';
import { ThemeProvider } from '@mui/material/styles';
import LogoutExpiredModal from '../../components/LogoutExpiredModal';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '10px',
    width: '558px',
    height: 'auto',
    overflow: 'auto',

}
const useStyles = makeStyles((theme) => ({
    LeadTable: {
        overflowX: 'auto',
        width: 'auto',
        borderRadius: '22px', boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
    },

}));
const AllLocation = () => {

    const [allLocation, setAllLocation] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [open, setOpen] = useState(false);
    const [deleteId, setDeleteId] = useState('');
    const navigate = useNavigate();
    const [Loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = React.useState(1);
    const [searchTerm, setSearchTerm] = React.useState('');
    const [totalPages, setTotalPages] = React.useState(0);
    const [logOutModal, setLogOutModal] = React.useState(false);
    const classes = useStyles();
    const theme = useTheme();
    const chartRef = useRef(null);
    const abortControllerRef = useRef(null);
    const columns = [
        {
            accessorKey: 'id',
            header: 'Sr no',
            size: 50,
            muiTableHeadCellProps: {
                sx: {
                    fontSize: '14px',
                },
            },
        },
        {
            accessorKey: 'region_name',
            header: 'Preferred Location',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            muiTableHeadCellProps: {
                sx: {
                    fontSize: '14px',
                },
            },
            size: 'auto',
        },

        {
            accessorKey: 'latitude',
            header: 'Latitude ',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            muiTableHeadCellProps: {
                sx: {
                    fontSize: '14px',
                },
            },
            size: 'auto',
        },

        {
            accessorKey: 'longitude',
            header: 'Longitude',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            muiTableHeadCellProps: {
                sx: {
                    fontSize: '14px',
                },
            },
            size: 'auto',
        },

        {
            id: 'actions',
            accessorKey: 'SeeMore',
            header: 'Action',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            size: 80,
            muiTableHeadCellProps: {
                align: 'center'
                , sx: {
                    fontSize: '14px',
                },
            },
            enableSorting: false,
            Cell: ({ row }) => {
                return (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>

                        <IconButton
                            aria-label="edit">
                            <EditLocation
                                locationId={row?.original?.id}
                                LocationName={row?.original?.region_name}
                                ValueLatitude={row?.original?.latitude}
                                ValueLongitude={row?.original?.longitude}
                                radius={row?.original?.radius}
                                organization_id={row?.original?.organization_id}
                                AllLocation={AllLocation}
                                currentPage={currentPage}

                            />
                        </IconButton>
                        {/* <IconButton
                            onClick={() => handleDeleteOpen(row?.original?.id)}
                            aria-label="delete">
                            <DeleteIcon sx={{ color: '#E71D36' }} />
                        </IconButton> */}
                    </div>
                );
            },
        }
    ]

    const AllLocation = async (currentPage, searchTerm, signal) => {
        setLoading(true)
        try {
            const isPaginated = 1
            const res = await LeadService.getLocationForAgent(currentPage, searchTerm, isPaginated, { signal });
            if (res?.data?.success) {
                setAllLocation(res?.data?.data?.data);
                setCurrentPage(res?.data?.data?.current_page || 1);
                setTotalPages(Math.ceil((res?.data?.data?.total || 1) / (res?.data?.data?.per_page || 1)));
                return;
            }
        }
        catch (error) {
            if (error.message === 'You have been logged out of the application, please login again to use the application.') {
                setLogOutModal(true);
            } else {
                toast.error(error.message);
            }
        } finally {
            setIsLoading(false)
            setLoading(false)
        }

    }

    const throttledAllLocation = useCallback(
        throttle((currentPage, searchTerm) => {
            AllLocation(currentPage, searchTerm);
        }, 2000), []
    );

    const fetchAllLocation = useCallback(
        debounce((currentPage, searchTerm) => {
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }
            const abortController = new AbortController();
            abortControllerRef.current = abortController;
            throttledAllLocation(currentPage, searchTerm, abortController.signal);
        }, 500), [throttledAllLocation]
    );

    useEffect(() => {
        fetchAllLocation(currentPage, searchTerm);
    }, [currentPage, searchTerm,]);

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1);
    };


    const handleClear = () => {
        setSearchTerm('');
        setCurrentPage(1);
        fetchAllLocation(1, '');
    };

    const handleClose = () => {
        setOpen(false)
    }

    const handleDeleteOpen = (id) => {
        setOpen(true);
        setDeleteId(id);
    }

    const HandleDeleteId = async (deleteId) => {
        try {
            setOpen(false);
            const res = await LeadService.deleteLocation(deleteId)
            if (res.data.success) {
                toast.success(res.data.message);
                fetchAllLocation(1, '');
                setOpen(false);
            }
        } catch (error) {
            toast.error(error.message);
        }
    }

    return (
        <div>
            <div style={{ marginBottom: '15px' }}> {Loading && <LinearProgress />}</div>


            <Box>
                <Box style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <AddPreferredLocation
                        AllLocation={AllLocation}
                    />

                </Box>
                <Box style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    // background: 'white',
                    padding: '10px',
                    borderRadius: '10px'
                }}>
                    <Box>
                        <Typography className="services-animated-text">Preferred Location</Typography>
                    </Box>
                    <TextField
                        value={searchTerm}
                        onChange={handleSearchChange}
                        sx={{
                            width: {
                                xs: "150px",
                                sm: "200px",
                                md: "250px"
                            }, '& .MuiOutlinedInput-root': {
                                borderRadius: '12px',
                            },
                        }}
                        placeholder="Search Preferred Location"
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={handleClear} aria-label="clear search">
                                        <ClearIcon />
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                        variant="outlined"
                    />

                </Box>
                <ThemeProvider theme={theme}>
                    <GlobalStyles
                        styles={{
                            '::-webkit-scrollbar': {
                                width: '14px', // Set the desired width for the scrollbar
                            },
                            '::-webkit-scrollbar-thumb': {
                                backgroundColor: '#c1c1c1', // Set the color for the scrollbar thumb
                                borderRadius: '10px', // Set the border radius for a rounded effect
                            },
                        }}
                    />
                    <div className={classes.LeadTable} style={{ marginTop: '2px', }}>
                        <MaterialReactTable
                            columns={columns}
                            data={allLocation}
                            state={{ isLoading: isLoading }}
                            muiCircularProgressProps={{
                                color: 'secondary',
                                thickness: 5,
                                size: 55,
                            }}
                            muiSkeletonProps={{
                                animation: 'pulse',
                                height: 28,
                            }}
                            enableTopToolbar={false}
                            enableFacetedValues={true}
                            enableDensityToggle={false}
                            enableHiding={false}
                            showSkeletons={false}
                            enableStickyHeader={true}
                            enableColumnFilterModes={false}
                            enableColumnActions={false}
                            enableColumnOrdering={false}
                            enableFullScreenToggle={false}
                            enableColumnFilters={false}
                            enablePagination={false}
                            getRowId={(row) => row.id}
                            initialState={{
                                showColumnFilters: false,
                                showGlobalFilter: false,
                            }}
                            muiTableBodyRowProps={{
                                sx: {
                                    backgroundColor: '#f5f5f5', // Default row background color
                                    '&:nth-of-type(odd)': {
                                        backgroundColor: '#ffffff', // Alternate rows with white
                                    },
                                    '&:hover': {
                                        backgroundColor: '#e0e0e0', // Hover effect
                                        cursor: 'pointer'
                                    },
                                },
                            }}

                        />

                    </div>
                </ThemeProvider>
                <Pagination
                    count={totalPages}
                    page={currentPage}
                    onChange={(event, value) => setCurrentPage(value)}
                    color="primary"
                    style={{ marginTop: '-40px', zIndex: 1000, position: 'relative', display: 'flex', justifyContent: 'flex-end' }}
                />
            </Box>

            {/* DeleteModal */}
            <Modal
                open={open}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <div style={{ marginTop: '20px', position: 'relative' }}>
                        <Box sx={{
                            display: 'grid',
                            padding: '10px',
                            gap: '10px',
                        }}>
                            <Box style={{ display: 'flex', justifyContent: 'center', gap: '15px' }}>
                                <Box>
                                    <DeleteIcon style={{ fontSize: '34px' }} />
                                </Box>
                                <Box style={{ display: 'grid', gap: '10px' }}>
                                    <div>
                                        <span style={{ fontSize: '20px', fontWeight: 'bold' }}>Are you sure you want to delete this Location?</span>
                                    </div>
                                    <div>
                                        <span style={{ fontSize: '16px', color: '#252F46' }}>This action will delete this Location permanently, and you can not undo this.</span>
                                    </div>
                                </Box>
                            </Box>
                        </Box>

                        <Box style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
                            <Button
                                onClick={handleClose}
                                style={{
                                    width: '140px',
                                    height: '43px',
                                    backgroundColor: 'white',
                                    fontWeight: '500',
                                    borderRadius: '4px',
                                    border: ' 1px solid #587DBF',
                                    color: '#252F46',
                                    fontSize: '15px',
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                onClick={() => HandleDeleteId(deleteId)}
                                style={{
                                    width: '140px',
                                    height: '43px',
                                    backgroundColor: '#5379BD',
                                    fontWeight: '500',
                                    borderRadius: '4px',
                                    border: ' 1px solid #587DBF',
                                    color: 'white',
                                    fontSize: '15px',
                                }}
                            >
                                Delete
                            </Button>
                        </Box>
                    </div>
                </Box>
            </Modal>
            <LogoutExpiredModal setLogOutModal={setLogOutModal} logOutModal={logOutModal}/>
        </div>
    )
}

export default AllLocation